import authHttp from "./authHttp";

export const getPaymentHistoryList = async (payload) => {
  const url = `/api/get-payment-details`;
  const { data } = await authHttp.post(url, payload);
  return data;
};
